import {defineStore} from "pinia";
import {SiteCheckInterface} from "./Interfaces/SiteCheckInterface";
import axios from "axios";
import {SiteCheckUrls} from "./Utils/SiteCheckUrls";

export const useSiteCheckStore = defineStore({
	id: 'SiteCheckStore',
	state: () => ({
		loaded: false,
		site: {} as SiteCheckInterface,
	}),
	actions: {
		async getSite() {
			return await axios.get(SiteCheckUrls.siteCheck)
				.then(response => {
					if (response.status === 200 && response.data.success === true) {
						this.site = response.data;
					}
				})
				.catch(() => {
				})
				.finally(() => this.loaded = true);
		},
	},
	getters: {
		isLoaded: (state): boolean => state.loaded,
		currentSite: (state): SiteCheckInterface => state.site,
	},
});
